export enum BookingStatus {
  NEW = 'NEW', // mới đặt nhưng chưa cọc
  LOCKED = 'LOCKED', //  đã cọc
  CANCELLED = 'CANCELLED', // huỷ
  REFUND = 'REFUND', // huỷ
  CHECKIN = 'CHECKIN', // đã checkin
  CHECKOUT = 'CHECKOUT', // đã checkout
  CONFLICT = 'CONFLICT', // trùng lịch
}
